const colors = {

    Purple: [
        '72,72,176,0.9',
        '72,72,176,0.6',
        '119,52,169,0.6'
    ],
    red: [
        '248,29,29,0.9',
        '248,29,29,0.6',
        '169,52,52,0.6'
    ],
    blue: [
        '29,140,248,0.9',
        '29,140,248,0.6',
        '29,140,248,0.6'
    ],
    green: [
        '72,176,101,0.9',
        '72,176,101,0.6',
        '69,248,29,0.6'
    ],
}


export const lineChartTransformer = (data, labelset) => {
    let lables = labelset ? labelset : 'title'
    let label = [], datasets = []
    data.map(res => {
        label.push(res[lables])
        datasets.push(res.value)
    })
    const chartData = (canvas) => {

        let ctx = canvas.getContext("2d");
        let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);
        gradientStroke.addColorStop(1, "rgba(29,248,197,0.2)");
        gradientStroke.addColorStop(0.4, "rgba(29,140,248,0.1)");
        gradientStroke.addColorStop(0, "rgba(29,140,248,0)"); //blue colors

        return {
            labels: label,
            datasets: [
                {
                    label: "سال",
                    fill: true,
                    backgroundColor: gradientStroke,
                    borderColor: "#1f8ef1",
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    pointBackgroundColor: "#1f8ef1",
                    pointBorderColor: "rgba(255,255,255,0)",
                    pointHoverBackgroundColor: "#1f8ef1",
                    pointBorderWidth: 20,
                    pointHoverRadius: 4,
                    pointHoverBorderWidth: 15,
                    pointRadius: 4,
                    lineTension: 0.2,
                    data: datasets,
                },
            ],
        };
    }
    return chartData
}


export const ReportBarChartTransformer = (data, labelType, color1) => {
    const chartColor = color1 ? colors[color1] : colors.Purple
    let labels = labelType ? labelType : 'locationName'
    let label = [], datasets = []
    debugger;        
    if(labels === 'locationName') {        
        data.values.sort((a,b) => +a.locationCode > +b.locationCode ? -1 : 1).map(res => {
            label.push(res[labels])
            datasets.push(res.value)
        })
    }
    else {
        data.values.map(res => {
            label.push(res[labels])
            datasets.push(res.value)
        })        
    }
    const chartData = (canvas) => {
        let ctx = canvas.getContext("2d");
        const barColors = [];


        let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);
       
        gradientStroke.addColorStop(1, `rgba(${chartColor[0]})`);
        gradientStroke.addColorStop(0.4, `rgba(${chartColor[1]})`);
        gradientStroke.addColorStop(0, `rgba(${chartColor[2]})`);

        label.map(i => barColors.push(gradientStroke));
        
        if( label.indexOf('کل کشور')>=0 ) {
            let gradientStroke0 = ctx.createLinearGradient(0, 230, 0, 50);
            gradientStroke0.addColorStop(1, `rgba(${colors.red[2]})`);
            gradientStroke0.addColorStop(0.4, `rgba(${colors.red[1]})`);
            gradientStroke0.addColorStop(0, `rgba(${colors.red[0]})`);        

            barColors[0] = gradientStroke0
        }

        return {
            labels: label,
            datasets: [
                {
                    label: "مقدار",
                    fill: true,
                    backgroundColor: barColors,
                    hoverBackgroundColor: gradientStroke,
                    borderColor: `rgba(${chartColor[2]})`,
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: datasets,
                },
            ],
        };
    }
    return chartData
}

export const BarChartTransformer = (data, labelType, color) => {
    const chartColor = color ? colors[color] : colors.Purple
    let labels = labelType ? labelType : 'locationName'
    let label = [], datasets = []
    
    data.map(res => {
        label.push(res[labels])
        datasets.push(res.value)
    })
    const chartData = (canvas) => {
        let ctx = canvas.getContext("2d");
        let gradientStroke = ctx.createLinearGradient(0, 230, 0, 50);

        gradientStroke.addColorStop(1, `rgba(${chartColor[0]})`);
        gradientStroke.addColorStop(0.4, `rgba(${chartColor[1]})`);
        gradientStroke.addColorStop(0, `rgba(${chartColor[2]})`);

        return {
            labels: label,
            datasets: [
                {
                    label: "مقدار",
                    fill: true,
                    backgroundColor: gradientStroke,
                    hoverBackgroundColor: gradientStroke,
                    borderColor: `rgba(${chartColor[2]})`,
                    borderWidth: 2,
                    borderDash: [],
                    borderDashOffset: 0.0,
                    data: datasets,
                    
                },
            ],
        };
    }
    return chartData
}


export const pieChartTransformer = (data,labelType) => {
    let label = labelType ? labelType : 'title'
    let chartdata = []
    let labels = []
    data.map(d => {
        labels.push(d[label])
        chartdata.push(+d.value)

    })
    const datasets = {
        labels: labels,
        datasets: [{
            data: chartdata, backgroundColor: [
                "#BA68C8",
                "#F06292",
                "#64B5F6",
                "#5C6BC0",
                "#9575CD",
                "#4FC3F7",
                "#4DB6AC",
                "#EEEEEE",
                "#EEEEEE",]
        }
        ]

    };
    return datasets
}